// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@media screen and (min-width: 768px) {
    .paddingToogle{
      padding: 10px;
    }
    .paddingToggleS{
        padding-top: 25px;
        padding-bottom: 25px;
      }
    .fontTog{
        font-size: xx-large ;
    }
}
@media screen and (max-width: 767px) {
    .paddingToogle{
        padding: 5px;
      }
      .paddingToogleS{
        padding-top: 7px;
        padding-bottom: 7px;
      }
      .fontTog{
        font-size: large;
      }
}

.selectTog{
color:black;
background-color: #D9D9D9;
}
.unselTog{
color:white;
background-color: #5062B3;
}


.input-group-container {
    position: relative;
    padding: 0;
    z-index: 1;
}

.search-input {
    padding-right: 90px; /* Make room for the button inside the input */
    border: 1px solid white;
}

.search-button {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    background-color: #FFAA6C;
    z-index: 5;
    color: black;
    border: none;
    padding: 5px 10px;
    cursor: pointer;
    border-radius: 5px;
    margin:0px;
}
.search-input::placeholder {
    color: white; /* Set the placeholder text color to white */
}
.search-button:hover {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background-color: #FFAA6C;
  z-index: 5;
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  border-radius: 5px;
  margin:0px;
}

.search-button:disabled {
    background-color: yellow;
    color:black;
    cursor: not-allowed;
}


@media screen and (max-width: 767px) {
    .wrapSubCard{
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 50px;
        margin-bottom: 50px;
      }
      .textM{
        margin-left: 0px;
        margin-right: 0x;
        margin-top: 30px;
        text-align: center;
        min-width: 100%;
      }
      .imgM{
        align-self: center;
      }
      
}
@media screen and (min-width: 768px) {
    .wrapSubCard{
        flex-wrap: nowrap;
        justify-content: start;
        margin-top: 30px;
        margin-bottom: 30px;
      }
      .textM{
        margin-left: 20px;
        margin-right: 0x;
        text-align: start;
      }
      .imgM{
        align-self: start;
      }
}

.btnunsub{
background-color:transparent;
border:1px solid white;
color:white;
}

.btnunsub:hover{
  color:black;
  background-color:transparent;
border:1px solid black;
}

.btnsub{
  background-color:#FFAA6C;
   border:1px solid white;
   color:white;
}
.btnsub:hover{
  background-color:#FFAA6C;
   border:1px solid black;
   color:black;
}`, "",{"version":3,"sources":["webpack://./src/Components/Podcast/section1pod.css"],"names":[],"mappings":";AACA;IACI;MACE,aAAa;IACf;IACA;QACI,iBAAiB;QACjB,oBAAoB;MACtB;IACF;QACI,oBAAoB;IACxB;AACJ;AACA;IACI;QACI,YAAY;MACd;MACA;QACE,gBAAgB;QAChB,mBAAmB;MACrB;MACA;QACE,gBAAgB;MAClB;AACN;;AAEA;AACA,WAAW;AACX,yBAAyB;AACzB;AACA;AACA,WAAW;AACX,yBAAyB;AACzB;;;AAGA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;AACd;;AAEA;IACI,mBAAmB,EAAE,8CAA8C;IACnE,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,yBAAyB;IACzB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,YAAY,EAAE,4CAA4C;AAC9D;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,yBAAyB;EACzB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,mBAAmB;AACvB;;;AAGA;IACI;QACI,eAAe;QACf,uBAAuB;QACvB,gBAAgB;QAChB,mBAAmB;MACrB;MACA;QACE,gBAAgB;QAChB,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB;QAClB,eAAe;MACjB;MACA;QACE,kBAAkB;MACpB;;AAEN;AACA;IACI;QACI,iBAAiB;QACjB,sBAAsB;QACtB,gBAAgB;QAChB,mBAAmB;MACrB;MACA;QACE,iBAAiB;QACjB,gBAAgB;QAChB,iBAAiB;MACnB;MACA;QACE,iBAAiB;MACnB;AACN;;AAEA;AACA,4BAA4B;AAC5B,sBAAsB;AACtB,WAAW;AACX;;AAEA;EACE,WAAW;EACX,4BAA4B;AAC9B,sBAAsB;AACtB;;AAEA;EACE,wBAAwB;GACvB,sBAAsB;GACtB,WAAW;AACd;AACA;EACE,wBAAwB;GACvB,sBAAsB;GACtB,WAAW;AACd","sourcesContent":["\n@media screen and (min-width: 768px) {\n    .paddingToogle{\n      padding: 10px;\n    }\n    .paddingToggleS{\n        padding-top: 25px;\n        padding-bottom: 25px;\n      }\n    .fontTog{\n        font-size: xx-large ;\n    }\n}\n@media screen and (max-width: 767px) {\n    .paddingToogle{\n        padding: 5px;\n      }\n      .paddingToogleS{\n        padding-top: 7px;\n        padding-bottom: 7px;\n      }\n      .fontTog{\n        font-size: large;\n      }\n}\n\n.selectTog{\ncolor:black;\nbackground-color: #D9D9D9;\n}\n.unselTog{\ncolor:white;\nbackground-color: #5062B3;\n}\n\n\n.input-group-container {\n    position: relative;\n    padding: 0;\n    z-index: 1;\n}\n\n.search-input {\n    padding-right: 90px; /* Make room for the button inside the input */\n    border: 1px solid white;\n}\n\n.search-button {\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    background-color: #FFAA6C;\n    z-index: 5;\n    color: black;\n    border: none;\n    padding: 5px 10px;\n    cursor: pointer;\n    border-radius: 5px;\n    margin:0px;\n}\n.search-input::placeholder {\n    color: white; /* Set the placeholder text color to white */\n}\n.search-button:hover {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: #FFAA6C;\n  z-index: 5;\n  color: white;\n  border: none;\n  padding: 5px 10px;\n  cursor: pointer;\n  border-radius: 5px;\n  margin:0px;\n}\n\n.search-button:disabled {\n    background-color: yellow;\n    color:black;\n    cursor: not-allowed;\n}\n\n\n@media screen and (max-width: 767px) {\n    .wrapSubCard{\n        flex-wrap: wrap;\n        justify-content: center;\n        margin-top: 50px;\n        margin-bottom: 50px;\n      }\n      .textM{\n        margin-left: 0px;\n        margin-right: 0x;\n        margin-top: 30px;\n        text-align: center;\n        min-width: 100%;\n      }\n      .imgM{\n        align-self: center;\n      }\n      \n}\n@media screen and (min-width: 768px) {\n    .wrapSubCard{\n        flex-wrap: nowrap;\n        justify-content: start;\n        margin-top: 30px;\n        margin-bottom: 30px;\n      }\n      .textM{\n        margin-left: 20px;\n        margin-right: 0x;\n        text-align: start;\n      }\n      .imgM{\n        align-self: start;\n      }\n}\n\n.btnunsub{\nbackground-color:transparent;\nborder:1px solid white;\ncolor:white;\n}\n\n.btnunsub:hover{\n  color:black;\n  background-color:transparent;\nborder:1px solid black;\n}\n\n.btnsub{\n  background-color:#FFAA6C;\n   border:1px solid white;\n   color:white;\n}\n.btnsub:hover{\n  background-color:#FFAA6C;\n   border:1px solid black;\n   color:black;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
